//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {round, get} from 'lodash';
export default {
  props: {
    item: {
      type: Object,
      default: ()=>({}),
    },
    fold: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    round,
    get,
  },
};
